import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';

const Unauthorized = () => {
  const bgColor = useColorModeValue('white', 'gray.700');
  
  return (
    <Box
      textAlign="center"
      py={10}
      px={6}
      maxW="md"
      mx="auto"
      mt={20}
      bg={bgColor}
      borderRadius="lg"
      boxShadow="md"
    >
      <VStack spacing={6}>
        <Heading
          display="inline-block"
          as="h2"
          size="xl"
          bgGradient="linear(to-r, red.400, red.600)"
          backgroundClip="text"
        >
          Access Denied
        </Heading>
        <Text fontSize="lg">
          You don't have permission to access this page. This area requires higher
          privileges than your current account has.
        </Text>
        <Button
          as={RouterLink}
          to="/"
          colorScheme="blue"
          bgGradient="linear(to-r, blue.400, blue.500, blue.600)"
          color="white"
          variant="solid"
        >
          Go to Home
        </Button>
      </VStack>
    </Box>
  );
};

export default Unauthorized;